import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { GalleryType } from '@app/core/plugin';
import { CoreStateService } from '@app/core/services';
import { Observable } from 'rxjs';
import { Gallery } from '../../utils/home';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-card-system',
  templateUrl: './card-system.component.html',
  styleUrls: ['./card-system.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardSystemComponent implements OnInit {
  public readonly gallery = Gallery;

  public gallery$: Observable<GalleryType>;

  constructor(private coreStateService: CoreStateService) {}

  public ngOnInit() {
    this.gallery$ = this.coreStateService.plugin$.pipe(map((plugin) => plugin.handler.home.gallery));
  }
}
